"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCompleteMenu = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var mithril_1 = require("../../mithril");
var highlighter_1 = require("../../services/util/highlighter");
var menu_1 = require("../menu/menu");
var menu_item_1 = require("../menu/menu.item");
var mithril_component_1 = require("../mithril.component");
var theme_1 = require("../theme");
var autocomplete_menu_style_1 = require("./autocomplete.menu.style");
(0, theme_1.addStyles)(autocomplete_menu_style_1.Styles);
var DEFAULT_MAX_RESULTS = 5;
var emptyStr = function (str) { return str == null || str.trim() === ''; };
var AutoCompleteMenu = /** @class */ (function (_super) {
    tslib_1.__extends(AutoCompleteMenu, _super);
    function AutoCompleteMenu(ctx) {
        var _this = _super.call(this) || this;
        _this.ctx = ctx;
        _this.menu = new menu_1.MenuComponent({
            items: function () { return _this.items; },
            open: function () { return _this.canOpen(); },
            className: autocomplete_menu_style_1.CSS.container
        });
        return _this;
    }
    Object.defineProperty(AutoCompleteMenu.prototype, "nodes", {
        get: function () {
            return this.menu.view();
        },
        enumerable: false,
        configurable: true
    });
    AutoCompleteMenu.prototype.canOpen = function () {
        return this.ctx.inputState.focused && this.items.length > 0;
    };
    AutoCompleteMenu.prototype.isOpen = function () {
        return this.menu.isOpen;
    };
    Object.defineProperty(AutoCompleteMenu.prototype, "items", {
        get: function () {
            var _this = this;
            var _a = this.ctx, inputState = _a.inputState, _b = _a.maxResults, maxResults = _b === void 0 ? DEFAULT_MAX_RESULTS : _b;
            var items = this.ctx.options();
            if (emptyStr(inputState.value)) {
                return items
                    .slice(0, maxResults)
                    .map(function (val) { return _this.createMenuItem([{ highlighted: false, content: val.value }], val); });
            }
            var hasMatch = false;
            var highlighted = [];
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var item = items_1[_i];
                var match = highlighter_1.Highlighter.highlight(item.value, inputState.value);
                if (match.parts.length > 1) {
                    highlighted.push({ match: match, item: item });
                }
                else if (match.parts.length === 1 && match.parts[0].highlighted === true) {
                    // If there is only one part it may fully match the input string
                    highlighted.push({ match: match, item: item });
                    hasMatch = true;
                }
            }
            var options = highlighted
                .sort(function (a, b) { return b.match.score - a.match.score; })
                .slice(0, maxResults)
                .map(function (val) { return _this.createMenuItem(val.match.parts, val.item); });
            if (this.ctx.showNew && hasMatch === false) {
                var node = this.createMenuItem([
                    { highlighted: true, content: inputState.value },
                    { highlighted: false, content: ' ( new )' }
                ], { id: null, value: inputState.value });
                options.push(node);
            }
            return options;
        },
        enumerable: false,
        configurable: true
    });
    AutoCompleteMenu.prototype.createMenuItem = function (parts, option) {
        var _this = this;
        var text = parts.map(function (part) { return (0, mithril_1.m)('span', { className: part.highlighted ? autocomplete_menu_style_1.CSS.highlighted : '' }, part.content); });
        if (this.ctx.optionView != null) {
            return this.ctx.optionView(option, text);
        }
        return {
            view: menu_item_1.MenuItemComponent.view(text),
            action: function () { return _this.ctx.onselect(option); }
        };
    };
    tslib_1.__decorate([
        mobx_1.computed
    ], AutoCompleteMenu.prototype, "items", null);
    return AutoCompleteMenu;
}(mithril_component_1.IMithrilComponent));
exports.AutoCompleteMenu = AutoCompleteMenu;
//# sourceMappingURL=autocomplete.menu.js.map